import { AllMenusFilter } from "./AllMenusPage";
import { MenuModalState } from "../../../interfaces/meMenuInterfaces/interfaces";
import { MenuTypeType } from "@me-team/host/main/graphql/types";

export const initialValueFilter: AllMenusFilter = { search: null, menuTypeId: null };

export const initialMenuModalState: MenuModalState = {
    isOpen: false,
    mode: null,
    menu: null,
};

export const menuTypes: { key: string; label: string }[] = [
    { key: "DINE_IN", label: "Dine-In menu" },
    { key: "PICK_UP", label: "Pickup menu" },
    { key: "DELIVERY", label: "Delivery menu" },
];

export const menuTypeKeyMap = {
    delivery: "DELIVERY",
    "self-delivery": "PICK_UP",
    "for-establishment": "DINE_IN",
} as const;

export const menuTypeMap = {
    delivery: MenuTypeType.Delivery,
    "self-delivery": MenuTypeType.Pickup,
    "for-establishment": MenuTypeType.DineIn,
} as const;

export type MenuTypeKey = keyof typeof menuTypeMap;
